



































import Vue from 'vue';
import { mapState } from 'vuex';
import store from '@/store/index';

export default Vue.extend({
  data() {
    return {
      showAlertMessage: false,
    };
  },
  computed: {
    ...mapState(['mainLoading']),
  },
  watch: {
    '$store.state.alertMessageText': function (value) {
      if (value === '') {
        this.showAlertMessage = false;
      } else {
        this.showAlertMessage = true;
      }
    },
    '$vuetify.breakpoint': function (value) {
      this.$store.commit('setBreakpoint', value);
    },
  },
  mounted() {
    console.log('app mounted');
  },
  methods: {
    onResize(): void {
      store.commit('setWindowSize', { width: window.innerWidth, height: window.innerHeight });
    },
  },
});

